//@flow

import env from '../../../../environment';
import {
  getCreator,
  postCreator,
  deleteCreator,
  putCreator,
} from '../../../../http';

import type {PaginationResponse, StoreDevice} from '../../../../entities';

export const endpoints = Object.freeze({
  CONNECT_WSS_DEVICE: `${env.baseApiUrl}/im/admin/crm-messaging/whatsapp-web/connect-device`,
  GET_DEVICE_STATUS: `${env.baseApiUrl}/im/admin/crm-messaging/device/:deviceId/status`,
  GET_RAVEN_ACCOUNT: `${env.baseApiUrl}/im/admin/crm-messaging/account`,
  GET_DEVICES: `${env.baseApiUrl}/im/admin/crm-messaging/device`,
  GET_CONVERSATIONS: `${env.baseApiUrl}/im/admin/crm-messaging/conversation`,
  GET_CONVERSATION: `${env.baseApiUrl}/im/admin/crm-messaging/conversation/:conversationId`,
  REMOVE_DEVICE_WITHOUT_HISTORY: `${env.baseApiUrl}/im/admin/crm-messaging/device/:deviceId`,
  REMOVE_DEVICE: `${env.baseApiUrl}/im/admin/crm-messaging/device/:deviceId`,
  RECONNECT_DEVICE: `${env.baseApiUrl}/im/admin/crm-messaging/whatsapp-web/:deviceId/reconnect`,
  CONVERSATION_COUNT: `${env.baseApiUrl}/im/admin/crm-messaging/conversation/counts`,

  CONNECT_META_ACCOUNT: `${env.baseApiUrl}/im/admin/crm-messaging/meta-login-success`,
  GET_FB_MESSENGER_ACCOUNTS: `${env.baseApiUrl}/im/admin/crm-messaging/facebook-meta-user/:userId/fbmessenger/accounts`,
  GET_INSTAGRAM_ACCOUNTS: `${env.baseApiUrl}/im/admin/crm-messaging/facebook-meta-user/:userId/instagram/accounts`,

  GET_WHATSAPP_API_TEMPLATES: `${env.baseApiUrl}/im/admin/crm-messaging/whatsapp-api/:deviceId/template`,
  GET_WHATSAPP_API_ACCOUNTS: `${env.baseApiUrl}/im/admin/crm-messaging/whatsapp-api/accounts`,
  GET_WHATSAPP_API_CONNECT_DEVICE: `${env.baseApiUrl}/im/admin/crm-messaging/whatsapp-api/connect-device`,
  GET_WHATSAPP_API_MEDIA: `${env.baseApiUrl}/im/admin/crm-messaging/whatsapp-api/media`,

  CONNECT_INSTAGRAM_DEVICE: `${env.baseApiUrl}/im/admin/crm-messaging/instagram/connect-device`,
  CONNECT_FB_MESSENGER_DEVICE: `${env.baseApiUrl}/im/admin/crm-messaging/fbmessenger/connect-device`,

  GET_META_USERS: `${env.baseApiUrl}/im/admin/crm-messaging/facebook-meta-user`,
  DELETE_META_USER: `${env.baseApiUrl}/im/admin/crm-messaging/facebook-meta-user/:userId`,

  GET_CHATBOT_BY_ID: `${env.baseApiUrl}/winehouse/admin/crm/chatbot/:chatbotId`,
  EDIT_CHATBOT: `${env.baseApiUrl}/winehouse/admin/crm/chatbot/:chatbotId`,

  CHAT_DEVICE_BEHAVIOR: `${env.baseApiUrl}/winehouse/admin/crm/messaging/device/:deviceId/behavior`,

  CHAT_MESSAGE_BEHAVIOR: `${env.baseApiUrl}/winehouse/admin/crm/messaging/conversation/:conversationId/behavior`,
});

export const connectWhatsappWebDevice = postCreator(
  endpoints.CONNECT_WSS_DEVICE
);
export const getDeviceStatus = getCreator(endpoints.GET_DEVICE_STATUS);

export const removeDeviceWithoutHistoryApi = deleteCreator(
  endpoints.REMOVE_DEVICE_WITHOUT_HISTORY
);

export const removeDeviceApi = deleteCreator(endpoints.REMOVE_DEVICE);
export const reconnectDeviceApi = postCreator(endpoints.RECONNECT_DEVICE);

export const getRavenAccount = getCreator(endpoints.GET_RAVEN_ACCOUNT);
export const getDevices = getCreator(endpoints.GET_DEVICES);

export const getConversations = getCreator(endpoints.GET_CONVERSATIONS);
export const getConversationEndpoint = getCreator(endpoints.GET_CONVERSATION);

export const createMetaAccountApi = postCreator(endpoints.CONNECT_META_ACCOUNT);

export const getInstagramAccountsApi = getCreator(
  endpoints.GET_INSTAGRAM_ACCOUNTS
);

export const getFbMessengerAccountsApi = getCreator(
  endpoints.GET_FB_MESSENGER_ACCOUNTS
);

export const connectInstagramDeviceApi = postCreator(
  endpoints.CONNECT_INSTAGRAM_DEVICE
);

export const connectFbMessengerDeviceApi = postCreator(
  endpoints.CONNECT_FB_MESSENGER_DEVICE
);

export const deleteMetaUserApi = deleteCreator(endpoints.DELETE_META_USER);
export const getMetaUsersApi = getCreator(endpoints.GET_META_USERS);

export const getConversationCountApi = getCreator(endpoints.CONVERSATION_COUNT);

export const getWhatsappApiTemplatesApi = getCreator(
  endpoints.GET_WHATSAPP_API_TEMPLATES
);

export const getWhatsappApiAccountsApi = getCreator(
  endpoints.GET_WHATSAPP_API_ACCOUNTS
);

export const connectWhatsappApiDeviceApi = postCreator(
  endpoints.GET_WHATSAPP_API_CONNECT_DEVICE
);

export const getChatbotByIdApi = getCreator(endpoints.GET_CHATBOT_BY_ID);
export const editChatbotApi = putCreator(endpoints.EDIT_CHATBOT);

export const setChatDeviceBehaviorApi = postCreator(
  endpoints.CHAT_DEVICE_BEHAVIOR
);

export const setChatMessageBehaviorApi = postCreator(
  endpoints.CHAT_MESSAGE_BEHAVIOR
);

export const defaultPagination = {
  size: 32,
  page: 0,
};

export type ChatServiceType =
  | 'WHATSAPP_WEB'
  | 'INSTAGRAM'
  | 'FACEBOOK'
  | 'WHATSAPP_API';

export type PaginationRequests = {
  size: number,
  page: number,
};

export type GetDevicesResponsePagination = PaginationResponse<StoreDevice>;

export type GetRavenAccountResponse = {
  createdAt: number,
  enabled: boolean,
  type: 'store-raven-account',
  updatedAt: number,
};

type CollaboratorCount = {
  collaboratorId: string,
  count: number,
};

export type GetConversationCountResponse = {
  totalCount: number,
  personalCount: number,
  collaboratorCounts: CollaboratorCount[],
  requiresAssistanceCount: number,
};
